import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_delivery_note,
  get_delivery_note,
  update_delivery_note,
  get_sales_order_pending_details,
} from "../../../../Controllers/Sales/DO";
import forms from "../../../../Data/Forms/Sales/DO/forms";
import headers from "../../../../Data/Forms/Sales/DO/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import DeliveryNoteTable from "../../../../Data/Forms/Sales/DO/table";
import { ConsoleSqlOutlined } from "@ant-design/icons";

const DeliveryNoteForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [salesOrderPending, setSalesOrderPending] = useState(null);

  const getFilteredFormOptions = () => {
    const baseForm = forms[0];

    if (id) {
      return [baseForm];
    } else {
      const filteredOptions = baseForm.options.filter(
        (option) => option.name !== "Status",
      );

      return [
        {
          ...baseForm,
          options: filteredOptions,
        },
      ];
    }
  };

  const [values, setValues] = useState(getFilteredFormOptions());
  const [note, setNote] = useState();

  const focus = useRef([]);

  const [details, setDetails] = useState([]);

  const [totals, setTotals] = useState({
    total: "0.000",
  });

  const findFieldIndex = (fieldName) => {
    return values[0].options.findIndex((option) => option.name === fieldName);
  };

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(`description${i}`).textContent =
              `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (!v?.sale_price) {
            document.getElementById(`sale_price${i}`).textContent =
              `Sale price is required`;
            focus.current[`sale_price${i}`].current.focus();
          } else if (!v?.quantity || v?.quantity <= 0) {
            document.getElementById(`quantity${i}`).textContent =
              `Valid quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else if (v?.quantity > v?.max_quantity) {
            document.getElementById(`quantity${i}`).textContent =
              `Quantity cannot exceed pending quantity (${v?.max_quantity})`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    console.log("tabledata in totalsvalidation", tabledata);

    params = {
      status: true,
      data: {
        ...tabledata,
        id: id ? id : "",
        total: totals?.total,
        note: note,
        source: "Sales",
      },
    };
    return params;
  };

  const formdata = async (data) => {
    console.log("data in formdata", data);
    if (data?.status) {
      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data,
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);

          console.log("tabletotalvalidation", tabletotalvalidation.data);

          const payload = {
            ...tabletotalvalidation.data,
            sales_order: id
              ? tabletotalvalidation.data.sales_order ||
                salesOrderPending?.sales_order?._id
              : salesOrderPending?.sales_order?._id,
          };

          const delivery_note = id
            ? await update_delivery_note(payload)
            : await create_delivery_note(payload);
          if (delivery_note?.status) {
            navigate(-1);
            toast?.success(delivery_note?.message);
            setButtonLoader(false);
          } else {
            setButtonLoader(false);
            if (delivery_note?.status_code == 403) {
              window.location.href = "/unauthorized";
            } else {
              toast?.error(delivery_note?.message);
            }
          }
        }
      }
    }
  };

  const handleSalesOrderSelect = async (sales_order_id) => {
    if (sales_order_id) {
      const result = await get_sales_order_pending_details({
        id: sales_order_id,
      });

      if (result?.status && result?.data) {
        let customerOption;
        let salesManOption;
        let updatedValues;

        if (result.data.sales_order.customer) {
          const customer = result.data.sales_order.customer;
          customerOption = {
            value: customer._id,
            label:
              customer.name && customer.phone
                ? `${customer.name} (${customer.phone})`
                : customer.name || customer.phone || "",
          };
          updatedValues = [...values];
          updatedValues[0].options[1].form.value = customer._id;
          updatedValues[0].options[1].form.options = [customerOption];
        } else {
          customerOption = {
            value: null,
            label: "Walk-in-customer",
          };

          updatedValues = [...values];
          updatedValues[0].options[1].form.value = null;
          updatedValues[0].options[1].form.options = [customerOption];
        }

        if (result.data.sales_order.salesman) {
          const salesman = result.data.sales_order.salesman;
          salesManOption = {
            value: salesman._id,
            label:
              salesman.name && salesman.phone
                ? `${salesman.name} (${salesman.phone})`
                : salesman.name || salesman.phone || "",
          };

          updatedValues = [...values];
          updatedValues[0].options[5].form.value = salesman._id;
          updatedValues[0].options[5].form.options = [salesManOption];
        }

        setValues(updatedValues);
        setSalesOrderPending(result.data);
      } else {
        toast?.error("No pending items for this sales order");
        setSalesOrderPending(null);
      }
    } else {
      setSalesOrderPending(null);
      setDetails([]);
    }
  };

  const handleData = async (delivery_note_data) => {
    let customer = delivery_note_data?.customer?._id
      ? delivery_note_data?.customer?._id
      : null;
    let sales_order = delivery_note_data?.sales_order?._id
      ? delivery_note_data?.sales_order?._id
      : null;
    let number = delivery_note_data?.number ? delivery_note_data?.number : "";
    let date = delivery_note_data?.date ? delivery_note_data?.date : "";
    let due_date = delivery_note_data?.due_date
      ? delivery_note_data?.due_date
      : "";
    let salesman = delivery_note_data?.salesman?._id
      ? delivery_note_data?.salesman?._id
      : null;
    let status = delivery_note_data?.status ? delivery_note_data?.status : 0;

    let salesman_options = delivery_note_data?.salesman?._id
      ? [
          {
            value: delivery_note_data?.salesman?._id,
            label: delivery_note_data?.salesman?.name,
          },
        ]
      : null;

    let customer_option = delivery_note_data?.customer?._id
      ? [
          {
            value: delivery_note_data?.customer?._id,
            label:
              delivery_note_data?.customer?.name &&
              delivery_note_data?.customer?.phone
                ? delivery_note_data?.customer?.name +
                  " (" +
                  delivery_note_data?.customer?.phone +
                  ")"
                : delivery_note_data?.customer?.name
                  ? delivery_note_data?.customer?.name
                  : delivery_note_data?.customer?.phone
                    ? delivery_note_data?.customer?.phone
                    : "",
          },
        ]
      : null;

    let sales_order_options = delivery_note_data?.sales_order
      ? [
          {
            value: delivery_note_data?.sales_order?._id,
            label: `#SO-${delivery_note_data?.sales_order?.number}`,
          },
        ]
      : null;

    const currentValues = [...values];

    const customerIndex = findFieldIndex("Customer");
    const salesOrderIndex = findFieldIndex("Sales Order");
    const numberIndex = findFieldIndex("Number");
    const dateIndex = findFieldIndex("Date");
    const dueDateIndex = findFieldIndex("Due Date");
    const salesmanIndex = findFieldIndex("Salesman");
    const statusIndex = findFieldIndex("Status");

    if (customerIndex !== -1) {
      currentValues[0].options[customerIndex].form.value = customer;
      currentValues[0].options[customerIndex].form.options = customer_option;
    }

    if (salesOrderIndex !== -1) {
      currentValues[0].options[salesOrderIndex].form.value = sales_order;
      currentValues[0].options[salesOrderIndex].form.options =
        sales_order_options;
    }

    if (numberIndex !== -1) {
      currentValues[0].options[numberIndex].form.value = number;
    }

    if (dateIndex !== -1) {
      currentValues[0].options[dateIndex].form.value = date;
    }

    if (dueDateIndex !== -1) {
      currentValues[0].options[dueDateIndex].form.value = due_date;
    }

    if (salesmanIndex !== -1) {
      currentValues[0].options[salesmanIndex].form.value = salesman;
      currentValues[0].options[salesmanIndex].form.options = salesman_options;
    }

    if (statusIndex !== -1) {
      currentValues[0].options[statusIndex].form.value = status;
    }

    let data = [];

    delivery_note_data?.details?.map((value) => {
      data?.push({
        id: value?._id,
        sales_order_detail: value?.sales_order_detail,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        category: value?.description?.product?.category
          ? value?.description?.product?.category
          : null,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        sale_price: value?.sale_price,
        quantity: value?.delivered_quantity,
        total: value?.total,
      });
    });

    totals.total = delivery_note_data?.total;

    setValues(currentValues);
    setDetails([...data]);
    setTotals({ ...totals });
    setNote(delivery_note_data?.note);
    setLoader(false);
    setSalesOrderPending({
  sales_order: delivery_note_data.sales_order,
  details: data
});
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const delivery_note_data = await get_delivery_note(data);
      if (delivery_note_data?.status) {
        handleData(delivery_note_data?.data);
      } else {
        toast?.error(delivery_note_data?.message);
        setLoader(false);
      }
    } else {
      const filteredValues = getFilteredFormOptions();

      const dateIndex = findFieldIndex("Date");
      const dueDateIndex = findFieldIndex("Due Date");

      if (dateIndex !== -1) {
        filteredValues[0].options[dateIndex].form.value = new Date();
      }

      setValues(filteredValues);
      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const selectHandlers = {
    number: handleSalesOrderSelect,
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          selectHandlers={selectHandlers}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <DeliveryNoteTable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
                note={note}
                setNote={setNote}
                salesOrderPending={salesOrderPending}
                setSalesOrderPending={setSalesOrderPending}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default DeliveryNoteForm;
